import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

const FIELDWORKER_CREATE = gql(`
mutation FieldworkerCreate($input: GqlFieldworkerCreateInput!) {
  fieldworkerCreate(input: $input) {
    id
    userId
    isPayable
    isMyWheelsUser
    hasFinishedOnboarding
    hasOwnTransport
    address
  }
}
`);

export default function useFieldworkerCreate(userId: string) {
    const [fieldworkerCreate, { data, loading, error }] = useMutation(FIELDWORKER_CREATE, {
        refetchQueries: ["UserGetById", "UserGetAll"],
    });

    return {
        fieldworkerCreate: () =>
            fieldworkerCreate({
                variables: {
                    input: {
                        userId,
                    },
                },
            }),
        loading,
        error,
        data: data?.fieldworkerCreate,
    };
}
